/* jshint esversion: 6 */
import { getGoodsDetail } from "@/libs/api.js";
import utils from "../libs/utils";
const group = "vi";

const model = {
	VI_STORAGE: [], // 优惠券弹框标识
	GOODS_DETAIL: "", // 商品详情
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
	Object.keys(s).forEach((key) => {
		s[key] = state[key];
	});
};

export const actions = {
	[types.VI_STORAGE](store, storage) {
		let couponList = JSON.parse(JSON.stringify(store.getters[types.VI_STORAGE]));
		couponList.push(storage);
		new Set(couponList); //去重
		store.commit(types.VI_STORAGE, couponList);
	},
	// 获取商品详情
	[types.GOODS_DETAIL](store, query) {
		return getGoodsDetail(query).then((res) => {
			return res.data;
		});
	},
};
